export default "__VITE_ASSET__D9RH4ijm__"